import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Utilities} from '@shared/utilities/utilities.model';
import {InnerMessage, InnerMessagesService} from '@shared/service/inner-messages.service';
import {UploadFileService} from '@shared/service/upload-file.service';
import {GenericAttachedFile} from '@shared/components/view-files/models/attachments-interface';
import {TranslateContext} from '@shared/pipes/translate.pipe';
import {FileExtensionFromMimeTypeMap, FileMimeTypeModel} from '@shared/models/file-mime-type.model';
import { FormItemsModel } from 'app/authority/authority-shared/models/form-items.model';

@Component({
	selector: 'amd-generic-view-attachment-item',
	templateUrl: './generic-view-attachment-item.component.html',
	styleUrls: ['./generic-view-attachment-item.component.scss']
})
export class GenericViewAttachmentItemComponent implements OnInit, OnDestroy {

	@Input() file?						 			: GenericAttachedFile;
	@Input() canEdit					 			: boolean;
	@Input() translateContext 			: TranslateContext;
	@Input() item						 			  : FormItemsModel;
	@Output() itemClickEventEmitter : EventEmitter<GenericAttachedFile[]> = new EventEmitter<GenericAttachedFile[]>();

	mimeTypeSupportedForThumbnailList: FileMimeTypeModel[] = [FileMimeTypeModel.TIF, FileMimeTypeModel.TIFF,
		FileMimeTypeModel.GIF, FileMimeTypeModel.JPEG, FileMimeTypeModel.JPG, FileMimeTypeModel.PNG,
		FileMimeTypeModel.PDF];
	private intervalRef: NodeJS.Timer;
	private retry: number = 0;
	private maxRetry: number = 30;

	constructor(
		private uploadFileService: UploadFileService,
		public innerMessagesService: InnerMessagesService) {
	}

	ngOnInit(): void {
		this.loadAttachments();
	}

	ngOnDestroy(): void {
		clearInterval(this.intervalRef);
	}

	loadAttachments(): void {
		if (!Utilities.isVoid(this.file)) {
			if (!Utilities.isVoid(this.file.thumbnail_id)) {
				this.uploadFileService.downloadAttachedFile(this.file.thumbnail_id).subscribe(response => {
					this.setSrcForTagImg(response);
				});
			} else {
				this.uploadFileService.downloadThumbnail(this.file.file_manager_id).subscribe(response => {
					this.setSrcForTagImg(response);
				});
			}
		} else {
			this.file.blob = -1;
		}
	}

	setSrcForTagImg(response: any): void {
		if (response.ok) {
			this.file.blob = Utilities.getBlob(response, this.file.file_manager_name);
			this.setImage();
		} else {
			this.innerMessagesService.pushInnerMessage(new InnerMessage(InnerMessage.GENERIC_ERROR,
				InnerMessage.TYPE_ERROR, null, true));
		}
	}

	// javascript fa schifo
	// forse è solo perché non lo sai usare...
	private setImage(): void {
		this.intervalRef = setInterval(() => {
			try {
				document.getElementById(this.file.file_manager_id).setAttribute('src', window.URL.createObjectURL(this.file.blob));
				clearInterval(this.intervalRef);
			} catch (e) {
				this.retry++;
				if (this.retry > this.maxRetry) {
					clearInterval(this.intervalRef);
				}
			}
		}, 1000);
	}

	fileMimeTypeIsSupportedForThumbnailfile(mime_type: FileMimeTypeModel): boolean {
		if (mime_type) {
			return this.mimeTypeSupportedForThumbnailList.some(file_mime_type => file_mime_type === mime_type);
		} else {
			return false;
		}
	}

	getFileEstension(mime_type: FileMimeTypeModel): string {
		const type: string = FileExtensionFromMimeTypeMap.get(mime_type);
		return type ? type.replace('.', '') : '';
	}
}
